<template>
  <div>
  <div class='oversea full_layout'>
    <div><img src="/static/images/activty/importantupdate/update/update_01.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/update/update_02.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/update/update_03.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/update/update_04.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/update/update_05.jpg"></div>
  </div>
</div>
</template>
<script>
export default {
  name: '',
  components: {  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.importantUpdate'));
  },
  methods: {
  },
}

</script>
<style scoped>
.oversea{
  margin-top: 24px;
}
.oversea img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/importantupdate.vue